export const CLUB_PROMO = {
    title: 'Вступить в клуб',
    text: 'Присоединяйтесь к сообществу лидеров и предпринимателей, <br/> влияющих на будущее.',
    buttonText: 'Отправить заявку',
    action: 'clubOffer',
};
export const ABOUT_CLUB_CONTEXT = {
    benefits: {
        title: 'Forbes Club: сообщество лидеров',
        text: 'Клуб создан в&nbsp;2007&nbsp;году. Он&nbsp;регулярно проводит встречи с&nbsp;миллиардерами, регуляторами рынка, инвесторами, экспертами. Клуб объединяет предпринимателей, работающих в&nbsp;таких индустриях как информационные технологии, финансы, промышленность, ретейл, образование и&nbsp;других.',
        items: [
            {
                title: '300&nbsp;<span>+</span>',
                description: 'Участников',
            },
            {
                title: '36&nbsp;<span>+</span>',
                description: 'Сфер бизнеса ',
            },
            {
                title: '80&nbsp;<span>+</span>',
                description: 'Мероприятий в год',
            },
        ],
    },
    formats: {
        sliderTitle: 'Форматы Forbes Club',
        items: [
            {
                img: { src: require('~/assets/images/club/public.jpg'), alt: 'Фото - Public talk' },
                title: 'Public talk',
                membersCount: '200 участников',
                text: 'Встреча с&nbsp;миллиардерами, лидерами рынка. В&nbsp;ходе этих встреч резиденты клуба обсуждают бизнес-стратегии, риски и&nbsp;возможности. Спикерами клуба были глава Центрального банка Эльфира Набиуллина, предприниматели Владимир Евтушенков, Олег Бойко, Татьяна Ким (Бакальчук), Юрий Максимов...',
            },
            {
                img: { src: require('~/assets/images/club/talk.jpg'), alt: 'Фото - Предметный разговор' },
                title: 'Предметный разговор',
                membersCount: '200 участников',
                text: 'Дискуссия с&nbsp;экспертами, инвесторами. Встречи посвящены обсуждению трендов в&nbsp;экономике, бизнесе, технологий успеха. Мы&nbsp;проводили дискуссии с&nbsp;экономистами, со&nbsp;специалистами в&nbsp;области технологий, риск-менеджмента, с&nbsp;исследователями Ближнего Востока',
            },
            {
                img: { src: require('~/assets/images/club/forum.jpg'), alt: 'Фото -  Форум-группы' },
                title: 'Форум-группы',
                membersCount: '10 участников',
                text: 'Закрытые встречи резидентов. Проходят раз в&nbsp;месяц. Посвящены обсуждению профессиональных вопросов, личных стратегий. Повестку которых определяют сами участники. Для организации дискуссий мы&nbsp;приглашаем профессиональных модераторов, которые поддерживают ритм работы сообществ',
            },
            {
                img: { src: require('~/assets/images/club/dinner.jpg'), alt: 'Фото - Бизнес-ужины' },
                title: 'Бизнес-ужины',
                membersCount: '20 участников',
                text: 'Встреча в&nbsp;камерной атмосфере. Дискуссии резидентов с&nbsp;экспертами. На&nbsp;этих встречах мы&nbsp;обсуждаем вопросы инвестиций, кадрового менеджмента, развития технологий, масштабирования бизнеса, выхода на&nbsp;новые рынки. В&nbsp;качестве экспертов выступают приглашенные специалисты и&nbsp;резиденты клуба',
            },
            {
                img: { src: require('~/assets/images/club/meeting.jpg'), alt: 'Фото - Спортивные встречи' },
                title: 'Спортивные встречи ',
                membersCount: '20 участников',
                text: 'Дружеские встречи на&nbsp;спортивных площадках. Такие встречи проходят и&nbsp;зимой, и&nbsp;летом. Зимой мы&nbsp;проводили соревнования по&nbsp;лыжному спорту, встречались на&nbsp;катке. Летом соревновались на&nbsp;беговых дорожках, устраивали велопробеги. Часто участниками спортивных встреч являются чемпионы, профессиональные спортсмены',
            },
            {
                img: { src: require('~/assets/images/club/lifestyle.jpeg'), alt: 'Фото -  Lifestyle' },
                title: 'Lifestyle',
                membersCount: '20 участников',
                text: 'Встречи в&nbsp;театрах, галереях, выставочных залах. Резидентов Forbes Club рады видеть владельцы художественных салонов, галерей, организаторы фотовыставок. Мы&nbsp;были на&nbsp;экскурсии в&nbsp;здании Большого театра, на&nbsp;предпоказах моды, общались с&nbsp;кураторами выставок современного искусства, с&nbsp;художниками, работающими в&nbsp;сфере цифрового арта',
            },
        ],
    },
    possibilities: {
        title: 'Медиаплатформа Forbes Club',
        items: [
            {
                title: 'Журнал Forbes Club',
                text: 'Клуб выпускает собственный журнал Forbes Club, который выходит в&nbsp;одном пакете с&nbsp;журналом Forbes Russia. Резиденты клуба публикуют в&nbsp;этом журнале свои материалы',
            },
            {
                title: '«Бизнес-класс»',
                text: 'У&nbsp;Forbes Club есть собственный проект &laquo;Бизнес-класс&raquo; на&nbsp;YouTube',
            },
            {
                title: 'Соцсети и мессенджеры',
                text: 'Forbes Club поддерживает публичные и&nbsp;приватные страницы в&nbsp;социальных сетях, а&nbsp;также ведет каналы в&nbsp;мессенджерах',
            },
            { title: 'Собственный сайт', text: 'Сайт Forbes Club зарегистрирован как самостоятельное медиа' },
        ],
    },
};
export const ABOUT_SLIDER_LIMIT = 12;
export const ABOUT_SLIDER_OPTIONS = {
    itemWidth: {
        mobile: '80vw',
        mobileMedium: '80vw',
        mobileWide: '300px',
    },
};
export const ABOUT_FORMAT_SLIDER_OPTIONS = {
    itemWidth: {
        mobile: '80vw',
        mobileMedium: '80vw',
        mobileWide: '300px',
        tablet: '322px',
        desktopWide: '450px',
    },
};
